module.exports = __webpack_public_path__ + "img/onlinePlatformBg-xl.c956066f.jpg";